/**
 * TODO: add prop-types
 */
import dynamic from 'next/dynamic';
import { useRef, useState } from 'react';

import Block from 'shopper/components/Block';
import Button from 'shopper/components/Button';
import { Dropdown, DropdownItem } from 'shopper/components/Dropdown';
import Icon from 'shopper/components/Icon';

import { useModal } from 'providers/ModalProvider';
import { useUser } from 'providers/UserProvider';

import ReportDropdownOptions from './ReportDropdownOptions';

const EditOfferModal = dynamic(() => import('./EditOfferModal'), {
  ssr: false,
});

const OfferDropdownMobile = ({
  offerId,
  offerStatusName,
  offerInstructions,
  offerPrice,
  offerPriceType,
  offerCoupon,
  userId,
}) => {
  const { showModal } = useModal();
  const { LoggedInUser, loadingLoggedInUser } = useUser();
  const reportButtonElem = useRef(null);
  const [isOpen, setOpen] = useState();

  const onCloseDropdown = () => {
    setOpen(false);
  };

  return (
    <Block height="fit-content" position="relative">
      <Button
        type="ghost"
        size="size4"
        aria-label="Abrir opções da oferta"
        icon={<Icon name="more-alt" />}
        ref={reportButtonElem}
        ml={2}
        onClick={() => setOpen((prev) => !prev)}
      />
      <Dropdown
        align="right"
        openerRef={reportButtonElem}
        open={isOpen}
        onClickOutside={() => setOpen(false)}
      >
        {!loadingLoggedInUser &&
          LoggedInUser?.canEditOffer(userId, offerStatusName) && (
            <DropdownItem
              onClick={() =>
                showModal(EditOfferModal, {
                  isOpen: true,
                  offerId,
                  offerInstructions,
                  offerPrice,
                  offerPriceType,
                  offerCoupon,
                })
              }
            >
              Editar conteúdo
            </DropdownItem>
          )}
        <ReportDropdownOptions
          offerId={offerId}
          offerStatusName={offerStatusName}
          onCloseDropdown={onCloseDropdown}
        />
      </Dropdown>
    </Block>
  );
};

export default OfferDropdownMobile;
